import * as React from 'react'

import './ToolCard.css'

import IDraggable from '../IDraggable'
import IDragStartChainable from '../IDragStartChainable'

export interface ICardProps extends IDragStartChainable {
    name: string;
}

interface IPossibleDragInitiation {
    mouseDown: boolean,

    startX: number,
    startY: number,

    dragStarted: boolean
}

export class Card<PropsType extends ICardProps, StateType> extends React.Component<PropsType, StateType> implements IDraggable {
    private cardRef: React.RefObject<{}>;
    private possibleDragInitiation: IPossibleDragInitiation;

    public constructor(props: PropsType) {
        super(props);

        this.cardRef = React.createRef();

        this.possibleDragInitiation = {
            mouseDown: false,

            startX: 0,
            startY: 0,

            dragStarted: false
        };
    }

    public getElement() : any {
        return (this.getCardRef() as React.RefObject<{}>).current;
    }

    protected getCardRef(): any {
        return this.cardRef;
    }

    protected mouseDowned(event: React.MouseEvent) {
        if(event.button === 0) {
            this.possibleDragInitiation = {
                mouseDown: true,

                startX: event.pageX,
                startY: event.pageY,

                dragStarted: false
            };
        }
    };

    protected mouseUpped(event: React.MouseEvent) {
        if(event.button === 0) {
            this.possibleDragInitiation.mouseDown = false;
            this.possibleDragInitiation.dragStarted = false;
        }
    };

    protected mouseMoved(event: React.MouseEvent) {
        if(!this.isDragPossible()) {
            return;
        }

        if(this.possibleDragInitiation.mouseDown && !this.possibleDragInitiation.dragStarted) {
            const distance: number = 
                Math.sqrt(
                    Math.pow(this.possibleDragInitiation.startX-event.pageX, 2)
                    + Math.pow(this.possibleDragInitiation.startY-event.pageY, 2)
                );
            const threshold: number = 15;
            if(distance > threshold) {
                if(this.props.onDragStart) {
                    this.possibleDragInitiation.dragStarted = true;
                    event.pageX = this.possibleDragInitiation.startX;
                    event.pageY = this.possibleDragInitiation.startY;
                    this.props.onDragStart(event, this);
                }
            }
        }
    };

    protected mouseLeft(event: React.MouseEvent) {
        this.possibleDragInitiation.mouseDown = false;
    };

    protected isDragPossible() : boolean {
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/App/Elements/Card.tsx